export enum ProcessStatus {
  Pending = 0,
  Processed = 1,
  Error = 2,
}
